import React, { useState, useEffect } from 'react'
import { useAppSelector } from '../../../../redux/hooks'
import { KTIcon } from '../../../../_metronic/helpers'
import { getTenantBannerConfig } from './request'
import { useAuth } from '../../../../app/modules/auth'
import { BannerConfig, getBannerStyles, getBannerType, getIcon } from './TenantBannerConfig'

const TenantBanner: React.FC = () => {
  const tenantId = useAppSelector(state => state.TenantSlice.id)
  const { auth } = useAuth()
  const [bannerConfig, setBannerConfig] = useState<BannerConfig | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchBannerConfig = async () => {
      if (!auth?.api_token) {
        setLoading(false)
        return
      }
      try {
        const response = await getTenantBannerConfig(null, auth.api_token)
        setBannerConfig(response.data.data)
      } catch (error) {
        console.error('Error fetching banner config:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchBannerConfig()
  }, [tenantId, auth?.api_token])

  // Don't show banner if loading, no config, not active, or empty message
  if (loading || !bannerConfig || !bannerConfig.active || !bannerConfig.message?.trim()) {
    return null
  }

  return (
    <div 
      className={`alert alert-${getBannerType(bannerConfig.type)} mb-0`}
      role="alert"
      style={{
        ...getBannerStyles(bannerConfig.type),
        borderRadius: '0',
        padding: '12px 20px',
        margin: '0',
        fontSize: '14px',
        fontWeight: '500'
      }}
    >
      <div className="d-flex align-items-center">
        <KTIcon iconName={getIcon(bannerConfig.type)} className={`fs-2hx text-${getBannerType(bannerConfig.type)} me-4`} />
        <div className="flex-grow-1">
          {bannerConfig.message}
        </div>
      </div>
    </div>
  )
}

export default TenantBanner 